import {
  ltiDispatches,
  lti1p1Variables,
  lti1p3Variables
} from 'pages/integrations/containers/LtiIntegrationContainer/constants';
import { ltiConfigurationService } from 'services/integrations';
import { messageNotification } from 'helpers';

const fetchLtiConfigurations = () => {
  return (dispatch) => {
    dispatch(ltiDispatches.fetchLtiConfigurationsRequest());
    ltiConfigurationService
      .fetchLtiConfigurations()
      .then((ltiData) => dispatch(ltiDispatches.fetchLtiConfigurationsSuccess(ltiData)))
      .catch((error) => dispatch(ltiDispatches.fetchLtiConfigurationsFailure(error)));
  };
};

const createLtiConfigurations = (data, setIsLoading = () => {}) => {
  const mappedDict = mapLtiKeys(data);
  return (dispatch) => {
    ltiConfigurationService
      .createLtiConfiguration(mappedDict)
      .then((response) => {
        const message = response.data.message || 'LTI configuration updated.';
        const filterKey = response.data.filter_key;
        const successMessage = filterKey ? `${message} Filter key: ${filterKey}` : message;
        messageNotification('success', 'Success', successMessage);
        return dispatch(fetchLtiConfigurations());
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message || error.response?.data || 'There was an error updating LTI configuration.';
        const errors = error.response?.data?.errors;

        if (errors) {
          const errorDetails = Object.entries(errors)
            .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
            .join('\n');
          messageNotification('danger', 'Validation Error', errorDetails);
        } else {
          messageNotification('danger', 'Error', errorMessage);
        }
      })
      .finally(() => setIsLoading(false));
  };
};

const patchLtiConfigurations = (id, data, setIsLoading = () => {}) => {
  const mappedDict = mapLtiKeys(data);
  return (dispatch) => {
    ltiConfigurationService
      .patchLtiConfiguration(id, mappedDict)
      .then((response) => {
        const message = response.data.message || 'LTI configuration updated.';
        const filterKey = response.data.filter_key;
        const successMessage = filterKey ? `${message} Filter key: ${filterKey}` : message;
        messageNotification('success', 'Success', successMessage);
        return dispatch(fetchLtiConfigurations());
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message || error.response?.data || 'There was an error updating LTI configuration.';
        const errors = error.response?.data?.errors;

        if (errors) {
          // Handle validation errors
          const errorDetails = Object.entries(errors)
            .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
            .join('\n');
          messageNotification('danger', 'Validation Error', errorDetails);
        } else {
          messageNotification('danger', 'Error', errorMessage);
        }
      })
      .finally(() => setIsLoading(false));
  };
};

const deleteLtiConfiguration = (params) => {
  return (dispatch) => {
    ltiConfigurationService
      .deleteLtiConfiguration(params)
      .then((response) => {
        const message = response.data.message || response.data || 'LTI configuration deleted.';
        messageNotification('success', 'Success', message);
        return dispatch(fetchLtiConfigurations());
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message || error.response?.data || 'Error deleting LTI configuration';
        messageNotification('danger', 'Error', errorMessage);
      });
  };
};

const mapLtiKeys = (dict) => {
  const mappingDict = dict.version === 'lti_1p1' ? lti1p1Variables : lti1p3Variables;
  const newDict = {};

  for (const key in mappingDict) {
    newDict[mappingDict[key]] = dict[key];
  }

  return newDict;
};

export const ltiActions = {
  fetchLtiConfigurations,
  createLtiConfigurations,
  patchLtiConfigurations,
  deleteLtiConfiguration
};
